import { DataGridTemplate } from "../../../../shared/data-grid/data-grid.template";
import { RequestDetailService } from "./detail.service";

export class PrimaryPartGrid extends DataGridTemplate {
    constructor(private readonly detailService: RequestDetailService) {
        super();
        this.controls.add = false;
        this.controls.edit = false;
        this.controls.delete = false;
        this.controls.excel = false;
        this.pageable = false;
        this.sortable = false;
        this.saveUserSettings = false;

        this.title = 'Primary Part'
        this.detailService.primaryPart
            .subscribe(p => {
                this.refresh();
            });
    }
    columns: any[] = [
        {
            field: 'PartNumber',
            title: 'Part#',
        },
        {
            field: 'ProgramName',
            title: 'Program Name',
        },
        {
            field: 'PartType',
            title: 'Part Type',
        },
        {
            field: 'Location',
            title: 'Location',
        },
        {
            field: 'DesignPhase',
            title: 'Design Phase',
        },
        {
            field: 'PTE1UserName',
            title: 'PTE1',
        },
        {
            field: 'PTE2UserName',
            title: 'PTE2',
        },
        {
            field: 'PartStatus',
            title: 'Status',
        }
    ];

    read(opts: any): Promise<any> {
        return Promise.resolve(this.detailService.primaryPart.value);
    }
    create(parentEditDataItem: any): void {
        return null;
    }
    edit(dataItem: any): void {
        return null;
    }
    save(dataItem: any, isNew: boolean): Promise<any> {
        return Promise.resolve();
    }
    delete(dataItem: any): Promise<any> {
        return Promise.resolve();
    }
    editForm: null;
}
